/* global BX, FormUtils, Inputmask */
document.addEventListener('DOMContentLoaded', () => {
    const mainButtons = document.querySelectorAll('.profile-personal__nav-btn');
    const mainContents = document.querySelectorAll('.profile-personal-tab-content');
    const orderButtons = document.querySelectorAll('.cp-orders-nav__link');
    const orderContents = document.querySelectorAll('.cp-orders-tab-wrapper .cp-orders-subtab-content');

    const orderSubTabs = ['all', 'current', 'finished', 'canceled'];

    const switchMainTab = (targetTab) => {
        if (targetTab === 'exit') {
            window.location.href = '/personal/?logout=yes&clear_cache=Y';
            return;
        }

        if (targetTab) {
            mainButtons.forEach((btn) => btn.classList.remove('filter-nav__link--active'));
            mainContents.forEach((content) => {
                content.classList.remove('is-active');
                content.style.display = 'none';
            });

            const activeBtn = document.querySelector(`.profile-personal__nav-btn[data-tab="${targetTab}"]`);
            if (activeBtn) activeBtn.classList.add('filter-nav__link--active');

            const targetContent = document.getElementById(`tab-${targetTab}`);
            if (targetContent) {
                targetContent.classList.add('is-active');
                targetContent.style.display = 'block';
            }
        }
    };

    const switchOrderTab = (targetTab) => {
        const activeTab = orderSubTabs.includes(targetTab) ? targetTab : 'all';

        orderButtons.forEach((btn) => {
            if (btn.getAttribute('data-order-tab') === activeTab) {
                btn.classList.add('filter-nav__link--active');
            } else {
                btn.classList.remove('filter-nav__link--active');
            }
        });

        orderContents.forEach((content) => {
            if (content.id === `order-tab-${activeTab}`) {
                content.style.setProperty('display', 'flex');
            } else {
                content.style.setProperty('display', 'none');
            }
        });
    };

    mainButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            const targetTab = button.dataset.tab;
            if (targetTab !== 'exit') {
                e.preventDefault();
                window.location.hash = targetTab === 'orders' ? 'all' : targetTab;
            } else {
                switchMainTab(targetTab);
            }
        });
    });

    if (orderButtons.length > 0) {
        orderButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                const targetTab = button.dataset.orderTab;
                window.location.hash = targetTab;
            });
        });
    }

    const checkAllHashes = () => {
        const currentHash = window.location.hash.replace('#', '');

        if (orderSubTabs.includes(currentHash)) {
            switchMainTab('orders');
            switchOrderTab(currentHash);
            return;
        }

        const isValidMainTab = document.querySelector(`.profile-personal__nav-btn[data-tab="${currentHash}"]`);
        if (currentHash && isValidMainTab) {
            switchMainTab(currentHash);
        } else {
            switchMainTab('private');
        }
    };

    checkAllHashes();
    window.addEventListener('hashchange', checkAllHashes);
});

document.addEventListener('DOMContentLoaded', () => {
    const actions = {
        inputName: 'setName',
        inputEmail: 'setEmail',
        inputEmailConfirm: 'checkEmailCode',
        inputPhone: 'setTelephone',
        inputPhoneConfirm: 'checkSmsCode',
    };

    function isProfileLocked() {
        return !!document.getElementById('editPermText');
    }

    function checkLockStatus() {
        const locked = isProfileLocked();
        const targets = document.querySelectorAll('.js-edit-trigger, #js-pass-toggle-btn');
        targets.forEach((el) => {
            if (locked) {
                el.classList.add('cp-disabled');
            } else {
                el.classList.remove('cp-disabled');
            }
        });
    }

    checkLockStatus();

    function setFieldError(inputElement, message) {
        if (!inputElement || !message) return;
        const group = inputElement.closest('.form-content__group');
        if (group) {
            group.classList.add('error');
            const errorNode = group.querySelector('.form-content__error');
            if (errorNode) {
                errorNode.style.color = '';
                errorNode.textContent = message.trim().startsWith('*') ? message : `*${message}`;
            }
        }
    }

    function clearFieldError(inputElement) {
        if (!inputElement) return;
        const group = inputElement.closest('.form-content__group');
        if (group) {
            group.classList.remove('error');
            const errorNode = group.querySelector('.form-content__error');
            if (errorNode) errorNode.textContent = '';
        }
    }

    function setFieldSuccess(inputElement, customMessage = 'Сохранено!') {
        if (!inputElement) return;
        clearFieldError(inputElement);
        const group = inputElement.closest('.form-content__group');
        if (group) {
            const errorNode = group.querySelector('.form-content__error');
            if (errorNode) {
                errorNode.style.color = 'var(--color-green, #4FAD00)';
                errorNode.textContent = customMessage;
                setTimeout(() => {
                    errorNode.textContent = '';
                    errorNode.style.color = '';
                }, 5000);
            }
        }
    }

    document.querySelectorAll('.js-edit-trigger').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            if (isProfileLocked()) {
                e.preventDefault();
                return;
            }

            const targetId = btn.dataset.target;
            const input = document.getElementById(targetId);
            if (!input) return;

            const isEditing = btn.dataset.edit === 'true';

            if (!isEditing) {
                btn.dataset.edit = 'true';
                btn.textContent = 'Сохранить';
                btn.classList.remove('cp-btn-blue');
                btn.classList.add('cp-btn-green');
                input.removeAttribute('disabled');
                input.focus();

                const confirmBlock = document.getElementById(`${targetId}ConfirmBlock`);
                if (confirmBlock) confirmBlock.classList.add('hidden');
            } else {
                const val = input.value.trim();
                if (!val) {
                    setFieldError(input, 'Поле не может быть пустым');
                    return;
                }

                if (targetId === 'inputUIN' && !/^(\d{10}|\d{12})$/.test(val)) {
                    setFieldError(input, 'ИНН должен содержать 10 или 12 цифр');
                    return;
                }

                clearFieldError(input);

                const resetBtnToDefault = () => {
                    btn.dataset.edit = 'false';
                    btn.textContent = 'Изменить';
                    btn.classList.remove('cp-btn-green');
                    btn.classList.add('cp-btn-blue');
                    input.setAttribute('disabled', 'disabled');
                };

                if (targetId === 'inputUIN') {
                    BX.ajax
                        .runAction('compuproject:personal.api.actions.setLegalEntityData', {
                            data: {
                                uin: val,
                                name: document.getElementById('inputCompanyName').value,
                                fullName: document.getElementById('inputCompanyFullName').value,
                                kpp: document.getElementById('inputCompanyKPP').value,
                                address: document.getElementById('inputCompanyAddress').value,
                            },
                        })
                        .then((res) => {
                            if (res.status === 'success' && res.data && res.data.status === 'success') {
                                setFieldSuccess(input);
                                resetBtnToDefault();
                            } else {
                                const msg = (res.data && res.data.message) || 'Ошибка сохранения';
                                setFieldError(input, msg);
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            setFieldError(input, 'Ошибка при отправке запроса');
                        });
                } else {
                    let postData = {};
                    if (targetId === 'inputName') {
                        const parts = val.split(/ +/g);
                        postData = {name: parts[0], lastName: parts[1] || ''};
                    }
                    if (targetId === 'inputEmail') postData = {email: val};
                    if (targetId === 'inputPhone') postData = {phone: val};

                    BX.ajax
                        .runAction(`compuproject:personal.api.actions.${actions[targetId]}`, {data: postData})
                        .then((res) => {
                            if (res.status === 'success' && res.data && res.data.status === 'success') {
                                const confirmBlock = document.getElementById(`${targetId}ConfirmBlock`);

                                if (confirmBlock) {
                                    confirmBlock.classList.remove('hidden');
                                    setFieldSuccess(input, 'Код подтверждения отправлен!');
                                } else {
                                    setFieldSuccess(input);
                                    resetBtnToDefault();
                                }
                            } else {
                                const msg = (res.data && res.data.message) || 'Ошибка изменения данных';
                                setFieldError(input, msg);
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            setFieldError(input, 'Ошибка при обработке запроса');
                        });
                }
            }
        });
    });

    function submitConfirmCode(input) {
        const val = input.value.trim();
        if (val.length < 4) {
            setFieldError(input, 'Код слишком короткий');
            return;
        }

        clearFieldError(input);

        BX.ajax
            .runAction(`compuproject:personal.api.actions.${actions[input.id]}`, {
                data: {code: val},
            })
            .then((res) => {
                if (res.status === 'success' && res.data && res.data.status === 'success') {
                    const block = input.closest('.cp-confirm-wrapper');
                    if (block) block.classList.add('hidden');

                    const mainInputId = input.id.replace('Confirm', '');
                    const mainInput = document.getElementById(mainInputId);

                    if (mainInput) {
                        setFieldSuccess(mainInput, 'Данные успешно подтверждены и сохранены!');
                        mainInput.setAttribute('disabled', 'disabled');

                        const row = mainInput.closest('.registration-form__row');
                        if (row) {
                            const triggerBtn = row.querySelector('.js-edit-trigger');
                            if (triggerBtn) {
                                triggerBtn.dataset.edit = 'false';
                                triggerBtn.textContent = 'Изменить';
                                triggerBtn.classList.remove('cp-btn-green');
                                triggerBtn.classList.add('cp-btn-blue');
                            }
                        }
                    }
                    input.value = '';
                } else {
                    const errorMsg = (res.data && res.data.message) || 'Неверный код подтверждения!';
                    setFieldError(input, errorMsg);
                }
            })
            .catch((err) => {
                console.error(err);
                setFieldError(input, 'Ошибка проверки кода');
            });
    }

    document.querySelectorAll('#inputEmailConfirm, #inputPhoneConfirm').forEach((input) => {
        input.addEventListener('input', (e) => {
            let val = e.target.value.replace(/\D/g, '');
            if (val.length > 8) val = val.slice(0, 8);
            e.target.value = val;
        });

        input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                submitConfirmCode(input);
            }
        });
    });

    document.querySelectorAll('.js-confirm-submit').forEach((btn) => {
        btn.addEventListener('click', () => {
            const targetId = btn.dataset.target;
            const input = document.getElementById(targetId);
            if (input) {
                submitConfirmCode(input);
            }
        });
    });

    const uinInput = document.getElementById('inputUIN');
    if (uinInput && window.DADATA_CONFIG && typeof window.fetch === 'function') {
        const dl = document.createElement('datalist');
        dl.id = 'uinSuggestionsList';
        document.body.appendChild(dl);
        uinInput.setAttribute('list', dl.id);

        let timer = null;
        const cache = new Map();

        uinInput.addEventListener('input', () => {
            if (isProfileLocked()) return;
            const query = uinInput.value.trim();
            if (query.length < 3) {
                dl.innerHTML = '';
                return;
            }

            clearTimeout(timer);
            timer = setTimeout(() => {
                window
                    .fetch(window.DADATA_CONFIG.url, {
                        method: 'POST',
                        headers: {
                            Accept: 'application/json',
                            Authorization: `Token ${window.DADATA_CONFIG.token}`,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({query: query}),
                    })
                    .then((r) => r.json())
                    .then((res) => {
                        dl.innerHTML = '';
                        if (!res.suggestions) return;
                        res.suggestions.forEach((s) => {
                            if (!s.data || !s.data.inn) return;
                            const opt = document.createElement('option');
                            opt.value = s.data.inn;
                            opt.label = s.value;
                            dl.appendChild(opt);
                            cache.set(s.data.inn, s);
                        });
                    })
                    .catch((err) => console.error(err));
            }, 350);
        });

        const fillFields = (inn) => {
            const s = cache.get(inn);
            if (!s) return;
            document.getElementById('inputCompanyName').value = s.value || '';
            document.getElementById('inputCompanyFullName').value = s.data.name?.full_with_opf?.replace('/', '') || '';
            document.getElementById('inputCompanyKPP').value = s.data.kpp || '';
            document.getElementById('inputCompanyAddress').value = s.data.address?.value || '';
        };

        uinInput.addEventListener('change', () => {
            if (!isProfileLocked()) fillFields(uinInput.value.trim());
        });
    }

    const phoneInput = document.getElementById('inputPhone');
    FormUtils.setupPhoneMask(phoneInput);
    if (phoneInput && typeof Inputmask === 'function') {
        Inputmask({regex: '^\\+7 \\([0-9]{3}\\) [0-9]{3}-[0-9]{2}-[0-9]{2}$'}).mask(phoneInput);
    }

    const passToggleBtn = document.getElementById('js-pass-toggle-btn');
    const passForm = document.querySelector('.cp_profile__pass-from');
    if (passToggleBtn && passForm) {
        passToggleBtn.addEventListener('click', (e) => {
            if (isProfileLocked()) {
                e.preventDefault();
                return;
            }
            passForm.classList.toggle('hidden');
        });
    }

    document.querySelectorAll('.js-eye-toggle').forEach((eye) => {
        eye.addEventListener('click', () => {
            const input = eye.previousElementSibling;
            if (input) {
                const isPassword = input.type === 'password';
                input.type = isPassword ? 'text' : 'password';

                const icon = eye.querySelector('i');
                if (icon) {
                    if (isPassword) {
                        icon.classList.remove('fa-eye-slash');
                        icon.classList.add('fa-eye');
                    } else {
                        icon.classList.remove('fa-eye');
                        icon.classList.add('fa-eye-slash');
                    }
                }
            }
        });
    });

    const savePassBtn = document.getElementById('js-save-pass-btn');
    if (savePassBtn) {
        savePassBtn.addEventListener('click', () => {
            if (isProfileLocked()) return;
            const cur = document.getElementById('inputCurrentPass');
            const n1 = document.getElementById('inputNewPass');
            const n2 = document.getElementById('inputConfirmPass');

            if (!cur.value) {
                setFieldError(cur, 'Введите текущий пароль');
                return;
            } else {
                clearFieldError(cur);
            }
            if (n1.value.length < 6) {
                setFieldError(n1, 'Минимум 6 символов');
                return;
            } else {
                clearFieldError(n1);
            }
            if (n1.value !== n2.value) {
                setFieldError(n2, 'Пароли не совпадают');
                return;
            } else {
                clearFieldError(n2);
            }

            BX.ajax
                .runAction('compuproject:personal.api.actions.setPass', {
                    data: {currentPass: cur.value, newPass: n1.value, confirmPass: n2.value},
                })
                .then((res) => {
                    if (res.status === 'success' && res.data && res.data.status === 'success') {
                        cur.value = '';
                        n1.value = '';
                        n2.value = '';
                        passForm.classList.add('hidden');
                        const successBlock = document.getElementById('js-pass-success-block');
                        successBlock.classList.remove('hidden');
                        setTimeout(() => successBlock.classList.add('hidden'), 5000);
                    } else {
                        const msg = (res.data && res.data.message) || 'Ошибка смены пароля';
                        setFieldError(n2, msg);
                    }
                })
                .catch((err) => console.error(err));
        });
    }

    const unblockBtn = document.getElementById('editUnblockButton');
    if (unblockBtn && typeof BX.PopupWindowManager !== 'undefined') {
        unblockBtn.addEventListener('click', () => {
            const popup = BX.PopupWindowManager.create('editUnblockPopup', null, {
                zIndex: 100,
                closeIcon: true,
                titleBar: 'Подтверждение пароля',
                content: `
                    <div class="form-content__group cp-popup-group">
                        <input class="form-content__input" id="inputEditConfirm" type="password" placeholder="Введите ваш текущий пароль*">
                        <span class="form-content__error cp-block" id="inputEditConfirmHelp"></span>
                    </div>
                `,
                closeByEsc: true,
                autoHide: true,
                overlay: {backgroundColor: 'black', opacity: 500},
                buttons: [
                    new BX.PopupWindowButton({
                        text: 'Подтвердить',
                        className: 'cp-btn-text cp-btn-blue',
                        events: {
                            click: function () {
                                const inp = document.getElementById('inputEditConfirm');
                                const help = document.getElementById('inputEditConfirmHelp');
                                if (!inp.value) {
                                    help.textContent = '*Обязательное поле';
                                    return;
                                }

                                BX.ajax
                                    .runAction('compuproject:personal.api.actions.confirmEditPerm', {
                                        data: {pass: inp.value},
                                    })
                                    .then((res) => {
                                        if (res.status === 'success' && res.data === true) {
                                            popup.close();
                                            const banner = document.getElementById('editPermText');
                                            if (banner) banner.remove();
                                            checkLockStatus();
                                        } else {
                                            help.textContent = '*Неверный пароль';
                                        }
                                    })
                                    .catch((err) => console.error(err));
                            },
                        },
                    }),
                ],
            });
            popup.show();
        });
    }
});
